import GitHubIcon from '@material-ui/icons/GitHub'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import { about } from '../../portfolio'
import Type from './Type'
import './About.css'


const About = () => {
  const { name, role, description, titles, currentLocation, resume, social} = about
  const hour = new Date().getHours();
  let greet;
  if (hour < 12) {
    greet = 'Good morning';
  } else if (hour < 18) {
    greet = 'Good afternoon';
  } else {
    greet = 'Good evening';
  }
  return (
    <div className='about center'>
      {name && (
        <div>
          <h1> {greet}, </h1>
          <h1> I am <span className='about__name'>{name}.</span></h1>
        </div>
      )}

      {role && <h2 className='about__role'>A {role}.</h2>}
      <p className='about__desc'>{description && description}</p>
      <p className='about__location'>{currentLocation && currentLocation}</p>
      <div className='about__type'>
        {Array.isArray(titles) && titles.length > 0 && (
          <Type titles={titles} />
        )}
      </div>


      <div className='about__contact center'>
        {resume && (
          <a href={resume}>
            <span type='button' className='btn btn--outline'>
              Resume
            </span>
          </a>
        )}

        {social && (
          <>
            {social.github && (
              <a
                href={social.github}
                aria-label='github'
                className='link link--icon'
              >
                <GitHubIcon />
              </a>
            )}

            {social.linkedin && (
              <a
                href={social.linkedin}
                aria-label='linkedin'
                className='link link--icon'
              >
                <LinkedInIcon />
              </a>
            )}
          </>
        )}
      </div>

    </div>
  )
}

export default About
